import { render, staticRenderFns } from "./LayoutContentVerticalNav.vue?vue&type=template&id=d90c13c4&scoped=true&"
import script from "./LayoutContentVerticalNav.vue?vue&type=script&setup=true&lang=js&"
export * from "./LayoutContentVerticalNav.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LayoutContentVerticalNav.vue?vue&type=style&index=0&id=d90c13c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90c13c4",
  null
  
)

export default component.exports